import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import RequestDefinition from '../RequestDefinition';

import {inventoryHeader} from '../../data/inventory/inventory';

export default new RouteComponent(`${apiRoutePrefix}/parts/inventory`, () => {
    return (
        <div>
            <ObjectHeader data={ inventoryHeader }/>

            {/*<Box mb={ 3 }>*/}
            {/*    <Divider/>*/}
            {/*</Box>*/}

            {
                inventoryHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
